

import { createSlice } from "@reduxjs/toolkit";
import searchContent from "../../utils/searchData"

const initialState = {

    searchResults:[], 
    recentSearches: []

}


const searchSlice = createSlice({
    name: "search",
    initialState,
    reducers: {

        filterSearch: (state,action) =>{
            const searchText = action.payload
            const filteredData = searchContent.map((item) => {
                const kwResult = item.keyWords.filter((item) => {
                    return item.toLocaleLowerCase('tr').includes(searchText.toLocaleLowerCase('tr'))
                })
                const descResult = item.desc.toLocaleLowerCase('tr').includes(searchText.toLocaleLowerCase('tr'))
                return {...item, kwResult, descResult}
            })

            const asdas = filteredData.filter(item => {
                return (item.kwResult.length > 0 || item.descResult)
            })
            const key = "mainMenu"
            const asdas2 = asdas.reduce((gruplar, nesne) => {
                const deger = nesne[key];
                if (!gruplar[deger]) {
                  gruplar[deger] = { mainMenu: deger, menuList: [] };
                }
                gruplar[deger].menuList.push(nesne);
                return gruplar;
              }, {});

              state.searchResults = Object.values(asdas2)
        } ,

        clearSearchState: (state) => {
            return initialState
        }
    },
})


export const { filterSearch, clearSearchState } = searchSlice.actions
export default searchSlice.reducer